export const SUCCESS_RESPONSES = {
  OK: 200,
}

export const ERROR_RESPONSES = {
  USER_DETAILS_ERROR: 412,
  NOT_FOUND_ERROR: 404,
  USER_AUTH_ERROR: 403,
  USER_AUTHORIZE_ERROR: 422,
  SERVER_ERROR: 500,
  TIMEOUT_ERROR: 504,
}

export const OMNIO_RESPONSE_CODES = {
  NOT_VALID: 'OMNIO-0001',
  NOT_ENOUGH_FUNDS: 'OMNIO-0002',
  NOT_FOUND: 'OMNIO-0003',
  UNAVAILABLE: 'OMNIO-0004',
  AUTH_INVALID_CURRENCY: 'OMNIO-0005',
  AUTH_NOT_FOUND: 'OMNIO-0006',
  AUTH_UNAVAILABLE: 'OMNIO-0007',
  AUTH_UNKNOWN_ERROR: 'OMNIO-0008',
  INVALID_AMOUNT: 'OMNIO-0009',
  CARD_NOT_FOUND: 'OMNIO-0010',
  CARD_NOT_AVAILABLE: 'OMNIO-0011',
  UNKNOWN_ERROR: 'OMNIO-0012',
}
